import React from 'react';
import PropTypes from 'prop-types';

const MenuIcon = ({ fill }) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        // eslint-disable-next-line max-len
        d="M6 7.168C5.292 7.168 4.728 7.732 4.728 8.44C4.728 9.148 5.292 9.712 6 9.712C6.708 9.712 7.272 9.148 7.272 8.44C7.272 7.732 6.708 7.168 6 7.168Z"
        fill={fill}
      />
      <path
        // eslint-disable-next-line max-len
        d="M11 7.168C10.292 7.168 9.728 7.732 9.728 8.44C9.728 9.148 10.292 9.712 11 9.712C11.708 9.712 12.272 9.148 12.272 8.44C12.272 7.732 11.708 7.168 11 7.168Z"
        fill={fill}
      />
      <path
        // eslint-disable-next-line max-len
        d="M16 7.168C15.292 7.168 14.728 7.732 14.728 8.44C14.728 9.148 15.292 9.712 16 9.712C16.708 9.712 17.272 9.148 17.272 8.44C17.272 7.732 16.708 7.168 16 7.168Z"
        fill={fill}
      />
    </svg>
  );
};

MenuIcon.propTypes = {
  fill: PropTypes.string,
};

export default MenuIcon;
